import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {AsyncStatusesEnum} from '../../../../../libs/shared/helpers/src/types/asyncStatuses';
import {center} from '../../../../../libs/shared/ui/src/styles/mixins';
import {AsyncLoader} from '../../../common/loaders/asyncLoader';
import {Skeleton} from '../../../common/skeleton';

/*
 * Props.
 */

interface CellsLoaderProps {
  status: AsyncStatusesEnum;
  onRetryClick: Handler;
}

/*
 * Style.
 */

const StyledLoaderDiv = styled.div`
  grid-row: 1 / span 3;
  grid-column: 1;
  min-width: 0;
  pointer-events: none;

  & > * {
    pointer-events: all;
  }

  ${center()};
`;

const StyledNewLoaderDiv = styled.div`
  grid-row: 1 / span 3;
  grid-column: 1;
  min-width: 0;
  pointer-events: none;
  display: grid;
  align-content: flex-start;
  grid-auto-flow: row;
  grid-auto-rows: auto;
  grid-row-gap: 8px;
  padding: 13px 14px;
  padding-right: 8px;

  & > * {
    pointer-events: all;
  }
`;

/*
 * Component.
 */

export const CellsLoader: FC<CellsLoaderProps> = ({status, onRetryClick}) => {
  if (status !== AsyncStatusesEnum.FAILED) {
    return (
      <StyledNewLoaderDiv>
        <Skeleton borderRadius="4px" width="90px" height="20px" />
        <Skeleton borderRadius="8px" width="100%" height="84px" />
        <Skeleton borderRadius="8px" width="100%" height="84px" />
        <Skeleton borderRadius="8px" width="100%" height="84px" />
      </StyledNewLoaderDiv>
    );
  }

  return (
    <StyledLoaderDiv>
      <AsyncLoader status={status} shouldHideRetryAfterReconnect onRetryClick={onRetryClick} />
    </StyledLoaderDiv>
  );
};
